import React from "react";

function DashboardActividad({ kpis }) {
    const cards = [
        {
            label: "Total facturas",
            value: kpis?.total_facturas ?? 0,
            tone: "text-blue-700 bg-blue-50 border-blue-100",
        },
        {
            label: "Total canjes",
            value: kpis?.total_canjes ?? 0,
            tone: "text-emerald-700 bg-emerald-50 border-emerald-100",
        },
        {
            label: "Total movimientos",
            value: kpis?.total_movimientos ?? 0,
            tone: "text-violet-700 bg-violet-50 border-violet-100",
        },
        {
            label: "Monto facturas",
            value: kpis?.monto_facturas_format || "Gs. 0",
            tone: "text-indigo-700 bg-indigo-50 border-indigo-100",
        },
        {
            label: "Monto canjes",
            value: kpis?.monto_canjes_format || "Gs. 0",
            tone: "text-cyan-700 bg-cyan-50 border-cyan-100",
        },
        {
            label: "Monto total",
            value: kpis?.monto_total_format || "Gs. 0",
            tone: "text-slate-700 bg-slate-50 border-slate-100",
        },
        {
            label: "Ticket promedio",
            value: kpis?.ticket_promedio_format || "Gs. 0",
            tone: "text-amber-700 bg-amber-50 border-amber-100",
        },
    ];

    return (
        <section className="mb-6">
            <div className="mb-4">
                <h2 className="text-xl font-bold text-gray-900">Resumen General</h2>
                <p className="text-sm text-gray-500">Indicadores clave del periodo seleccionado.</p>
            </div>

            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
                {cards.map((item) => (
                    <div key={item.label} className={`rounded-xl border p-4 shadow-sm ${item.tone}`}>
                        <p className="text-xs font-semibold uppercase tracking-wide opacity-80">{item.label}</p>
                        <p className="mt-2 text-lg font-bold leading-tight break-words">{item.value}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default DashboardActividad;
